import Slider from "react-slick";
import { IHomeSlide } from "../../types/home_slider";

function MobileSliderComponent({ ...props }) {
  const hasMultipleSlides = props.slides.length > 1;

  const settings = {
    dots: hasMultipleSlides,
    infinite: hasMultipleSlides,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dir: "auto",
    rtl: true,
    autoplay: hasMultipleSlides,
    arrows: false,
  };

  return (
    <div className="col-lg-9 align-self-center position-relative d-lg-none d-block">
      <Slider className="slider-body slick-dots slider-body-home" {...settings}>
        {props.slides.map((slideRow: IHomeSlide, index: any) => {
const imageUrl = slideRow?.attributes?.Image?.data?.attributes?.formats?.large?.url ?? slideRow?.attributes?.Image?.data?.attributes?.url;
const title = slideRow?.attributes?.Title;
          const url = slideRow?.attributes?.Url;

          return (
            <div className="slider-item" key={index}>
              <div className="slider-inner-item">
                {imageUrl && (
                  <img
                    src={`${process.env.REACT_APP_CMS}${imageUrl}`}
                    alt="img"
                    className="img-fluid"
                  />
                )}
                {title && url && (
                  <h3 dir="auto">
                    <a href={url}>{title}</a>
                  </h3>
                )}
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

export default MobileSliderComponent;
